import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=aaf2997a&"
import script from "./ColorField.vue?vue&type=script&lang=js&"
export * from "./ColorField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports